import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from 'src/app/core/configs/app.settings';
import { HttpService } from 'src/app/core/data/service/http.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService extends HttpService {

  private ranCheck = false;
  get isChecked() { return this.ranCheck; }
  set isChecked(val: boolean) { this.ranCheck = val; }

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = `${this.apiURL}/config`;
  }

  async versionCheck() {
    if (this.isChecked === true) {
      return null;
    }
    this.isChecked = true;
    return await this.post('"' + AppSettings.version + '"');
  }

  messageCheck() {
    let url = 'https://app.bidbeacon.com/sysmessages/sys-msg-prod.json';
    if (AppSettings.apiURL.indexOf('arcbus.dev') > 0) {
      url = 'https://app.bidbeacon.com/sysmessages/sys-msg-dev.json';
    }
    return super.fetch(url + '?t=' + new Date().getTime());
  }

  protected isUpdate(entity: any) {
    return false;
  }

  protected getUpdateUrl(entity: any, endpoint: string = this.endpoint) {
    return '';
  }
}
